import { el } from './dom.js';

/**
 * The bonus goal's medal (ADR-0040): a brass disc with a star, on a ribbon.
 * Drawn the same on the goal card, in play, on the results and on the home
 * screen's floors, lit once the goal is met and an outline until then.
 */
export function medalSvg(lit: boolean): SVGSVGElement {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('viewBox', '0 0 20 24');
  svg.setAttribute('aria-hidden', 'true');
  svg.classList.add('medal');
  svg.dataset.lit = String(lit);
  svg.innerHTML =
    '<path class="medal-ribbon" d="M5 1h4l2 7H7zM15 1h-4L9 8h4z"/>' +
    '<circle class="medal-disc" cx="10" cy="15" r="7.2"/>' +
    '<path class="medal-star" d="M10 10.6l1.3 2.7 2.9.4-2.1 2 .5 2.9L10 17.2l-2.6 1.4.5-2.9-2.1-2 2.9-.4z"/>';
  return svg;
}

/** "Bonus · Lose nobody · +14": the goal and what it pays the first time. */
export function bonusLine(text: string, coins: number, lit = false): HTMLElement {
  return el('div', { class: 'bonus-line' }, [
    medalSvg(lit),
    el('span', { class: 'bonus-kicker', text: 'Bonus' }),
    el('span', { class: 'bonus-text', text }),
    ...(coins > 0 ? [el('span', { class: 'bonus-coins', text: `+${coins}` })] : []),
  ]);
}
